import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

if (screen.width > 767) {
    // Parralax animation
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.page-header--home',
            pin: true,
            scrub: 0.8,
            start: 'top top',
            end: "+=100%",
        },
    });

    let logoHeight;

    if ( screen.width < 767 ) {
        logoHeight = 34;
    } else {
        logoHeight = 62;
    }

    timeline
        .to('.logo__section__logo', {
            height: `${logoHeight}px`,
            y: 0,
        }, '<')
        .to('.page-header--home__overlay', {
            y: "0",
        }, '<')
        .to('.page-header--home__overlay-bg', {
            opacity: "0.5",
        }, '<')
        .to('.logo__section__logo__text', {
            opacity: 0,
            x: '-100%',
            duration: 0.1,
        })
        .to('.logo__section__logo__beeldmerk', {
            x: "-680px",
            scale: 1.4,
            duration: 0.1,
        }, '<')
    ;
}

// On scroll hide meta data from logo.
if( $('.logo__section__logo__meta') ) {
    const metaData = $('.logo__section__logo__meta');
    const headerStyle = () => {
        if( $(window).scrollTop() > 100 ) {
            metaData.addClass('hide-meta');
        } else {
            metaData.removeClass('hide-meta');
        }
    }

    $(document).on('scroll', function(){
        headerStyle();
    })

    $(document).on('ready', function() {
        headerStyle();
    })
}

// Text animation
const timeline2 = gsap.timeline({
    scrollTrigger: {
        trigger: '.module--text',
        pin: false,
        scrub: 0.4,
        start: 'top bottom',
        end: "+=100%",
    },
});

timeline2
    .from('.module--text__content__title', {
        opacity: 0,
        x: '-50%',
    })
    .from('.module--text__content__text', {
        opacity: 0,
        x: '-60%',
    }, '<')
    .from('.module--text__content__button', {
        opacity: 0,
        x: '-70%',
    }, '<')
;
